export const LOGIN_APP_PATH: string = "/login"
export const ACMG_STATUS_APP_PATH: string = "/acmg-status"
export const ACCESSIBILITY_STATEMENT_PATH: string = "/accessibility-statement"

export const ENV = process.env.REACT_APP_BUILD_ENV ?? "dev";

export const SERVER_URL: string = `${process.env.REACT_APP_SERVER_URL}${ENV}`


export const SEND_OTP_PATH: string = "/send-otp"
export const GET_PATIENT_DATA_PATH: string = "/patient-data"
export const CHECK_IF_USER_LOCKED_PATH: string = "/verify-locked"

export const PATIENT_DATA_STORAGE_ITEM_NAME: string = "patientDataStorageItem"
export const SESSION_ID_STORAGE_ITEM_NAME: string = "sessionIdStorageItem"
export const LANGUAGE_ITEM_NAME: string = "languageStorageItem"


export const SESSION_TIMEOUT_SECONDS: number = 5 * 60

export const MAX_VERIFY_OTP_ERROR = "max verify otp attempts reached";
export const MAX_SEND_OTP_ERROR = "max send otp attempts reached";

export const MAX_SEND_ATTEMPTS = 5;
